import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'

Vue.use(VueRouter)

export default new VueRouter({
  routes
})



// WEBPACK FOOTER //
// ./src/vue/router/index.js